/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfIListOfGetUserAgentsByCpDto } from '../models/custom-result-of-i-list-of-get-user-agents-by-cp-dto';
import { CustomResultOfIListOfGetUserAgentsQueryDto } from '../models/custom-result-of-i-list-of-get-user-agents-query-dto';
import { CustomResultOfLoadAgentDto } from '../models/custom-result-of-load-agent-dto';
import { CustomResultOfPaginatedListOfSmsSenderAgentDto } from '../models/custom-result-of-paginated-list-of-sms-sender-agent-dto';
import { smsSenderAgentsCreateGet } from '../fn/sms-sender-agents/sms-sender-agents-create-get';
import { SmsSenderAgentsCreateGet$Params } from '../fn/sms-sender-agents/sms-sender-agents-create-get';
import { smsSenderAgentsCreatePost } from '../fn/sms-sender-agents/sms-sender-agents-create-post';
import { SmsSenderAgentsCreatePost$Params } from '../fn/sms-sender-agents/sms-sender-agents-create-post';
import { smsSenderAgentsDelete } from '../fn/sms-sender-agents/sms-sender-agents-delete';
import { SmsSenderAgentsDelete$Params } from '../fn/sms-sender-agents/sms-sender-agents-delete';
import { smsSenderAgentsGetSmsSenderAgentAudits } from '../fn/sms-sender-agents/sms-sender-agents-get-sms-sender-agent-audits';
import { SmsSenderAgentsGetSmsSenderAgentAudits$Params } from '../fn/sms-sender-agents/sms-sender-agents-get-sms-sender-agent-audits';
import { smsSenderAgentsGetSmsSenderAgentsWithPagination } from '../fn/sms-sender-agents/sms-sender-agents-get-sms-sender-agents-with-pagination';
import { SmsSenderAgentsGetSmsSenderAgentsWithPagination$Params } from '../fn/sms-sender-agents/sms-sender-agents-get-sms-sender-agents-with-pagination';
import { smsSenderAgentsGetUserAgents } from '../fn/sms-sender-agents/sms-sender-agents-get-user-agents';
import { SmsSenderAgentsGetUserAgents$Params } from '../fn/sms-sender-agents/sms-sender-agents-get-user-agents';
import { smsSenderAgentsGetUserAgentsByCp } from '../fn/sms-sender-agents/sms-sender-agents-get-user-agents-by-cp';
import { SmsSenderAgentsGetUserAgentsByCp$Params } from '../fn/sms-sender-agents/sms-sender-agents-get-user-agents-by-cp';
import { smsSenderAgentsUpdateGet } from '../fn/sms-sender-agents/sms-sender-agents-update-get';
import { SmsSenderAgentsUpdateGet$Params } from '../fn/sms-sender-agents/sms-sender-agents-update-get';
import { smsSenderAgentsUpdatePut } from '../fn/sms-sender-agents/sms-sender-agents-update-put';
import { SmsSenderAgentsUpdatePut$Params } from '../fn/sms-sender-agents/sms-sender-agents-update-put';

@Injectable({ providedIn: 'root' })
export class SmsSenderAgentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `smsSenderAgentsGetSmsSenderAgentsWithPagination()` */
  static readonly SmsSenderAgentsGetSmsSenderAgentsWithPaginationPath = '/SmsSenderAgents/GetSmsSenderAgentsWithPagination';

  /**
   * Get SmsSenderAgents with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsSenderAgentsGetSmsSenderAgentsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsSenderAgentsGetSmsSenderAgentsWithPagination$Response(params: SmsSenderAgentsGetSmsSenderAgentsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfSmsSenderAgentDto>> {
    return smsSenderAgentsGetSmsSenderAgentsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get SmsSenderAgents with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsSenderAgentsGetSmsSenderAgentsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsSenderAgentsGetSmsSenderAgentsWithPagination(params: SmsSenderAgentsGetSmsSenderAgentsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfSmsSenderAgentDto> {
    return this.smsSenderAgentsGetSmsSenderAgentsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfSmsSenderAgentDto>): CustomResultOfPaginatedListOfSmsSenderAgentDto => r.body)
    );
  }

  /** Path part for operation `smsSenderAgentsGetUserAgentsByCp()` */
  static readonly SmsSenderAgentsGetUserAgentsByCpPath = '/SmsSenderAgents/GetUserAgentsByCp';

  /**
   * عامل ارسال بر اساس cp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsSenderAgentsGetUserAgentsByCp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsSenderAgentsGetUserAgentsByCp$Response(params: SmsSenderAgentsGetUserAgentsByCp$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfIListOfGetUserAgentsByCpDto>> {
    return smsSenderAgentsGetUserAgentsByCp(this.http, this.rootUrl, params, context);
  }

  /**
   * عامل ارسال بر اساس cp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsSenderAgentsGetUserAgentsByCp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsSenderAgentsGetUserAgentsByCp(params: SmsSenderAgentsGetUserAgentsByCp$Params, context?: HttpContext): Observable<CustomResultOfIListOfGetUserAgentsByCpDto> {
    return this.smsSenderAgentsGetUserAgentsByCp$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfIListOfGetUserAgentsByCpDto>): CustomResultOfIListOfGetUserAgentsByCpDto => r.body)
    );
  }

  /** Path part for operation `smsSenderAgentsGetUserAgents()` */
  static readonly SmsSenderAgentsGetUserAgentsPath = '/SmsSenderAgents/GetUserAgents';

  /**
   * For DropDownList, Return Id and Name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsSenderAgentsGetUserAgents()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsSenderAgentsGetUserAgents$Response(params?: SmsSenderAgentsGetUserAgents$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfIListOfGetUserAgentsQueryDto>> {
    return smsSenderAgentsGetUserAgents(this.http, this.rootUrl, params, context);
  }

  /**
   * For DropDownList, Return Id and Name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsSenderAgentsGetUserAgents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsSenderAgentsGetUserAgents(params?: SmsSenderAgentsGetUserAgents$Params, context?: HttpContext): Observable<CustomResultOfIListOfGetUserAgentsQueryDto> {
    return this.smsSenderAgentsGetUserAgents$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfIListOfGetUserAgentsQueryDto>): CustomResultOfIListOfGetUserAgentsQueryDto => r.body)
    );
  }

  /** Path part for operation `smsSenderAgentsGetSmsSenderAgentAudits()` */
  static readonly SmsSenderAgentsGetSmsSenderAgentAuditsPath = '/SmsSenderAgents/GetSmsSenderAgentAudits';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsSenderAgentsGetSmsSenderAgentAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsSenderAgentsGetSmsSenderAgentAudits$Response(params: SmsSenderAgentsGetSmsSenderAgentAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return smsSenderAgentsGetSmsSenderAgentAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsSenderAgentsGetSmsSenderAgentAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsSenderAgentsGetSmsSenderAgentAudits(params: SmsSenderAgentsGetSmsSenderAgentAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.smsSenderAgentsGetSmsSenderAgentAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `smsSenderAgentsCreateGet()` */
  static readonly SmsSenderAgentsCreateGetPath = '/SmsSenderAgents/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsSenderAgentsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsSenderAgentsCreateGet$Response(params?: SmsSenderAgentsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smsSenderAgentsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsSenderAgentsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsSenderAgentsCreateGet(params?: SmsSenderAgentsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smsSenderAgentsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smsSenderAgentsCreatePost()` */
  static readonly SmsSenderAgentsCreatePostPath = '/SmsSenderAgents/Create';

  /**
   * Create SmsSenderAgent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsSenderAgentsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsSenderAgentsCreatePost$Response(params: SmsSenderAgentsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smsSenderAgentsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create SmsSenderAgent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsSenderAgentsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsSenderAgentsCreatePost(params: SmsSenderAgentsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smsSenderAgentsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smsSenderAgentsUpdatePut()` */
  static readonly SmsSenderAgentsUpdatePutPath = '/SmsSenderAgents/Update/{id}';

  /**
   * Update SmsSenderAgent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsSenderAgentsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsSenderAgentsUpdatePut$Response(params: SmsSenderAgentsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smsSenderAgentsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update SmsSenderAgent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsSenderAgentsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsSenderAgentsUpdatePut(params: SmsSenderAgentsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smsSenderAgentsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smsSenderAgentsUpdateGet()` */
  static readonly SmsSenderAgentsUpdateGetPath = '/SmsSenderAgents/Update';

  /**
   * SmsSenderAgent LoadAgent by smsSenderAgentId for edit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsSenderAgentsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsSenderAgentsUpdateGet$Response(params?: SmsSenderAgentsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfLoadAgentDto>> {
    return smsSenderAgentsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * SmsSenderAgent LoadAgent by smsSenderAgentId for edit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsSenderAgentsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsSenderAgentsUpdateGet(params?: SmsSenderAgentsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfLoadAgentDto> {
    return this.smsSenderAgentsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfLoadAgentDto>): CustomResultOfLoadAgentDto => r.body)
    );
  }

  /** Path part for operation `smsSenderAgentsDelete()` */
  static readonly SmsSenderAgentsDeletePath = '/SmsSenderAgents/Delete';

  /**
   * Delete SmsSenderAgent.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsSenderAgentsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsSenderAgentsDelete$Response(params?: SmsSenderAgentsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smsSenderAgentsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete SmsSenderAgent.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsSenderAgentsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsSenderAgentsDelete(params?: SmsSenderAgentsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smsSenderAgentsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
